import { ChangeEvent, FC, FocusEvent, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IInputState } from '../../types';
import { InputProps } from '../types';
import { checkValidEmail, validateMailInputValue } from 'utils';
import { BaseInput } from '../base-input';

/* Принимает в себя все пропсы BaseInput, подробно описаны в BaseInput. */
export const EmailInput: FC<InputProps> = observer(({ ...inputProps }) => {
  const [inputState, setInputState] = useState<IInputState>(
    inputProps?.state || 'default'
  );

  const updateState = () => {
    setInputState(
      !!inputProps.value
        ? checkValidEmail(String(inputProps.value))
          ? 'success'
          : 'error'
        : 'default'
    );
  };

  useEffect(() => {
    updateState();
  }, [inputProps.value]);

  const upgradedOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.currentTarget.value = validateMailInputValue(e.currentTarget.value);
    inputProps?.onChange && inputProps.onChange(e);
  };

  const upgradedOnBlur = (e: FocusEvent<HTMLInputElement>) => {
    updateState();
    inputProps?.onBlur && inputProps.onBlur(e);
  };

  return (
    <BaseInput
      state={inputState}
      message={{
        success: 'Корректный Email',
        warning: 'Некорректный Email',
        error: 'Некорректный Email',
      }}
      placeholder={'Введите Email'}
      {...inputProps}
      onChange={upgradedOnChange}
      onBlur={upgradedOnBlur}
    />
  );
});
